import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import ErrorBoundary from './ErrorBoundary';
// import moment from 'moment';

const root = ReactDOM.createRoot(document.getElementById('root'));
// const version = "V202403270924";

let smallurl, url, version;
    
// smallurl = 'https://localhost:44379';
// url = 'https://localhost:44379/Crm/';

smallurl = 'https://www.tribuapi.fr';
url = 'https://www.tribuapi.fr/Crm/';

version = "V202609070853";

root.render(
    //   <React.StrictMode>
    // <ErrorBoundary>
    <App version={version} smallurl={smallurl} url={url} />
    // </ErrorBoundary>
    //   </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
